import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import axios from "axios";
import { useAuth } from "../../../../../../../../../context/AuthContext";
import ReactPlayer from 'react-player'
import { getActiveTags } from './Services/TagService';
import { getActiveCourses, getAllActiveSubjects, getSubjectsByCourseId } from './Services/ContentService';
import { updateContent } from './Services/ContentManagerService';

const Match = (props) => {
    const { t } = useTranslation();
    const { user } = useAuth();

    // -- State'ler --
    const [msg, setMsg] = useState("");
    const [tags, setTags] = useState([]);
    const [courses, setCourses] = useState([]);
    const [subjects, setSubjects] = useState([]);

    // Yükleme Durumları
    const [loadingTags, setLoadingTags] = useState(true);
    const [loadingCourses, setLoadingCourses] = useState(true);
    const [loadingSubjects, setLoadingSubjects] = useState(true);

    // Form Kontrol State'leri (document.getElementById yerine)
    const [tagId, setTagId] = useState("");
    const [courseId, setCourseId] = useState("");
    const [subjectId, setSubjectId] = useState("");
    const [notfyText, setNotfyText] = useState("");
    const [questionTextState, setQuestionTextState] = useState("");
    const [answer, setAnswer] = useState("");
    const [splitMode, setSplitMode] = useState("auto");

    // Soru ve Medya State'leri
    const [question, setQuestion] = useState({});
    const [questionType, setQuestionType] = useState("bos");
    const [questionMedia, setQuestionMedia] = useState("");
    const [multicontentsoundurl, setMulticontentsoundurl] = useState("");

    const urlFile = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
    const headersFile = {
        "accept": "*/*",
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + user.token
    };

    // --- API İstekleri ---
    const taglist = async () => {
        setLoadingTags(true);
        try {
            const activeTags = await getActiveTags(user.token);
            setTags(activeTags);
        } catch (err) {
            setMsg(err.message || "Etiket listesi yüklenirken hata oluştu.");
        } finally {
            setLoadingTags(false);
        }
    };

    const courseList = async () => {
        setLoadingCourses(true);
        try {
            const activeCourses = await getActiveCourses(user.token);
            setCourses(activeCourses);
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingCourses(false);
        }
    };

    const subjectlist = async () => {
        setLoadingSubjects(true);
        try {
            const activeSubjects = await getAllActiveSubjects(user.token);
            setSubjects(activeSubjects);
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingSubjects(false);
        }
    };

    const courseselectchange = async (e) => {
        const selectedCourseId = e.target.value;
        setCourseId(selectedCourseId);
        try {
            const filteredSubjects = await getSubjectsByCourseId(selectedCourseId, user.token);
            setSubjects(filteredSubjects);
        } catch (err) {
            setMsg(err.message);
        }
    };

    const executeAction = async (payload) => {
        try {
            const res = await updateContent(payload, user.token);
            if (res.success) {
                Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Soru listesi sayfasına Dön`,
                    timer: 500,
                }).then(() => {
                    window.location.reload();
                });
            } else {
                setMsg(res.message);
            }
        } catch (err) {
            setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
        }
    };

    // --- Jenerik Medya Yükleme Fonksiyonu ---
    // 9 Farklı fonksiyonun yaptığı işi tek başına yapar
    const handleMediaAction = async (e, apiMediaType, buildPayloadCallback) => {
        if (e.target.type === "textarea") {
            const newUrl = e.target.value;
            updateQuestionMedia(buildPayloadCallback(newUrl));
        } else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const res = await axios.post(urlFile, formData, {
                    params: { mediaType: apiMediaType },
                    headers: headersFile
                });
                const uploadedUrl = "https://api.heryerdeingilizce.com/" + res.data.data.path;
                alert("Yüklendi");
                updateQuestionMedia(buildPayloadCallback(uploadedUrl));
            } catch (err) {
                setMsg(err.message);
            }
        }
    };

    const updateQuestionMedia = async (obj) => {
        executeAction({
            ...props.data,
            contentStr: JSON.stringify(obj)
        });
    };

    // --- Ortak Medya Silme ---
    const handleDeleteMedia = async (e) => {
        e.preventDefault();
        if (questionType === "image_sound") {
            alert("Hem resim hem ses içeren sorularda medyayı tekli silmek desteklenmemektedir. Her ikisi birden silinir!");
        }
        executeAction({
            ...props.data,
            notfyText: notfyText,
            contentStr: JSON.stringify({ type: "text", url: "", text: questionTextState })
        });
    };

    // --- Form Güncelleme İşlemleri ---
    const updateTag = async (e) => {
        e.preventDefault();
        executeAction({ ...props.data, tagId });
    };

    const updateCourse = async (e) => {
        e.preventDefault();
        if (!subjectId) return alert("Subject seçmediniz!");
        executeAction({ ...props.data, subjectId });
    };

    const handleQuestion = async (e) => {
        e.preventDefault();
        const dataObj = JSON.parse(props.data.contentStr);
        dataObj.text = questionTextState;

        executeAction({
            ...props.data,
            notfyText,
            contentStr: JSON.stringify(dataObj),
        });
    };

    const tokenize = (rawInput, mode) => {
        const s = (rawInput ?? "").trim();
        if (!s) return [];
        if (mode === "mixed") {
            const bySpace = s.split(/\s+/).filter(Boolean);
            return bySpace.flatMap(t => t.split(/[-_]+/).filter(Boolean));
        }
        if (s.includes(" ")) return s.split(/\s+/).filter(Boolean);
        return s.split("");
    };

    const handleEdit = async (e) => {
        e.preventDefault();
        let parsedArray = tokenize(answer, splitMode);

        // Karıştırma İşlemi (Shuffle)
        for (let i = parsedArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [parsedArray[i], parsedArray[j]] = [parsedArray[j], parsedArray[i]];
        }

        const detailAnswer = parsedArray.map((service, id) => ({ id, service }));
        const qContent = JSON.parse(props.data.contentStr);
        qContent.mode = splitMode;

        executeAction({
            ...props.data,
            answer,
            contentStr: JSON.stringify(qContent),
            detail: JSON.stringify(detailAnswer)
        });
    };

    useEffect(() => {
        taglist();
        courseList();
        subjectlist();

        // Props'dan gelen verileri state'lere bağlama
        setTagId(props.data.tagId);
        setSubjectId(props.data.subjectId);
        setAnswer(props.data.answer || "");
        setNotfyText(props.data.notfyText || "");

        const questionData = JSON.parse(props.data.contentStr || "{}");
        setQuestion(questionData);
        setQuestionTextState(questionData.text || "");

        if (questionData.type === "text") {
            setQuestionType("bos");
        } else if (questionData.type === "image_sound") {
            setQuestionType(questionData.type);
            setMulticontentsoundurl(questionData.soundUrl);
            setQuestionMedia(questionData.url);
        } else {
            setQuestionType(questionData.type);
            setQuestionMedia(questionData.url);
        }

        setSplitMode(questionData.mode || "auto");
    }, []);

    return (
        <div>
            <br />
            <h3>Unscramble Sorusu</h3>
            <br />
            <h5>Uyarı: Her Kısımda Güncelle butonu mevcuttur. İlgili alanda yaptığınız değişiklik sonrası güncelleme yapınız lütfen.</h5>
            <hr /><br />
            {msg && <div className="alert alert-warning">{msg}</div>}

            <div>
                {/* --- ETİKET (TAG) GÜNCELLEME --- */}
                <form onSubmit={updateTag}>
                    {loadingTags ? <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div> : (
                        <div className='row' style={{ border: "1px solid black", padding: "10px" }}>
                            <div className="col-9">
                                <label className="form-label">{t("selecttag")}</label>
                                <select className="form-select" value={tagId} onChange={e => setTagId(e.target.value)}>
                                    {tags?.length > 0 ? tags.map((dt) => (
                                        <option key={dt.id} value={dt.id}>{dt.tagName}</option>
                                    )) : <option>{t("reloadWarning")}</option>}
                                </select>
                            </div>
                            <div className='col-3 d-flex align-items-end justify-content-center'>
                                <button type="submit" className="btn btn-primary btn-lg" >{t("update")}</button>
                            </div>
                        </div>
                    )}
                </form>
                <br /><hr />

                {/* --- KURS VE KONU (COURSE & SUBJECT) GÜNCELLEME --- */}
                <form onSubmit={updateCourse}>
                    <div style={{ border: "1px solid black", padding: "10px" }}>
                        <br />
                        {loadingCourses ? <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div> : (
                            <div className="mb-3">
                                <label className="form-label">{t("selectCourse")}</label>
                                <select className="form-select" value={courseId} onChange={courseselectchange}>
                                    <option value="">{t("selectCourse")}</option>
                                    {courses?.length > 0 ? courses.map((dt) => (
                                        <option key={dt.id} value={dt.id}>{dt.courseName} -- {dt.courseDesc}</option>
                                    )) : <option>{t("reloadWarning")}</option>}
                                </select>
                            </div>
                        )}

                        {loadingSubjects ? <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div> : (
                            <div className="mb-3">
                                <label className="form-label">{t("selectSubject")}</label>
                                <select className="form-select" value={subjectId} onChange={e => setSubjectId(e.target.value)}>
                                    <option value="">{t("selectSubject")}</option>
                                    {subjects?.length > 0 ? subjects.map((dt) => (
                                        <option key={dt.id} value={dt.id}>{dt.subjectName} // {dt.subjectDesc}</option>
                                    )) : <option>{t("reloadWarning")}</option>}
                                </select>
                            </div>
                        )}
                        <div className='d-flex justify-content-center'>
                            <button type="submit" className="btn btn-primary btn-lg">{t("update")}</button>
                        </div>
                    </div>
                </form>
                <hr />

                {/* --- MEDYA VE METİN (QUESTION) GÜNCELLEME --- */}
                <form onSubmit={handleQuestion} style={{ border: "1px solid black", padding: "10px" }}>
                    <hr />
                    {questionType !== 'bos' &&
                        <div>
                            {/* HEM RESİM HEM SES */}
                            {questionType === 'image_sound' &&
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex justify-content-center">
                                            <img style={{ width: "40%" }} src={questionMedia} alt="Soru görseli" />
                                        </div><hr />
                                        <div className="mb-3">
                                            <label className="form-label">{t("addPhoto")}</label>
                                            <input className="form-control" type="file" accept='image/*' onChange={(e) => handleMediaAction(e, 'photo', url => ({ text: questionTextState, type: 'image_sound', url: url, soundUrl: multicontentsoundurl }))} />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{t("addPhotobyUrl")}</label>
                                            <textarea className="form-control" rows={1} onChange={(e) => handleMediaAction(e, 'photo', url => ({ text: questionTextState, type: 'image_sound', url: url, soundUrl: multicontentsoundurl }))} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex justify-content-center">
                                            <ReactAudioPlayer src={multicontentsoundurl} controls />
                                        </div><hr />
                                        <div className="mb-3">
                                            <label className="form-label">{t("addSound")}</label>
                                            <input className="form-control" type="file" accept='audio/*' onChange={(e) => handleMediaAction(e, 'sound', url => ({ text: questionTextState, type: 'image_sound', url: questionMedia, soundUrl: url }))} />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{t("addSoundbyUrl")}</label>
                                            <textarea className="form-control" rows={1} onChange={(e) => handleMediaAction(e, 'sound', url => ({ text: questionTextState, type: 'image_sound', url: questionMedia, soundUrl: url }))} />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center w-100 mt-3'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={handleDeleteMedia}>Medya {t("delete")}</button>
                                    </div>
                                </div>}

                            {/* SADECE RESİM */}
                            {questionType === 'image' &&
                                <div className="row" style={{ border: "1px solid", padding: "1%" }}>
                                    <div className='col'>
                                        <img style={{ width: "40%" }} src={questionMedia} alt="Soru görseli" />
                                        <div>
                                            <label className="form-label">{t("addPhoto")}</label>
                                            <input className="form-control" type="file" accept='image/*' onChange={(e) => handleMediaAction(e, 'photo', url => ({ text: questionTextState, type: 'image', url: url }))} />
                                        </div>
                                        <div>
                                            <label className="form-label">{t("addPhotobyUrl")}</label>
                                            <textarea className="form-control" rows={1} onChange={(e) => handleMediaAction(e, 'photo', url => ({ text: questionTextState, type: 'image', url: url }))} />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className="mb-3">
                                            <label className="form-label">{t("addSound")}</label>
                                            <input className="form-control" type="file" accept='audio/*' onChange={(e) => handleMediaAction(e, 'sound', url => ({ text: questionTextState, type: 'image_sound', url: questionMedia, soundUrl: url }))} />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center w-100 mt-3'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={handleDeleteMedia}>Medya {t("delete")}</button>
                                    </div>
                                </div>}

                            {/* SADECE VİDEO */}
                            {questionType === 'video' &&
                                <div>
                                    <div className="d-flex justify-content-center">
                                        <ReactPlayer className='react-player' url={questionMedia} controls={true} />
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="mb-3">
                                            <label className="form-label">{t("addVideo")}</label>
                                            <input className="form-control" type="file" accept='video/*' onChange={(e) => handleMediaAction(e, 'video', url => ({ text: questionTextState, type: 'video', url: url }))} />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{t("addVideobyUrl")}</label>
                                            <textarea className="form-control" rows={1} onChange={(e) => handleMediaAction(e, 'video', url => ({ text: questionTextState, type: 'video', url: url }))} />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center w-100 mt-3'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={handleDeleteMedia}>Medya {t("delete")}</button>
                                    </div>
                                </div>}

                            {/* SADECE SES */}
                            {questionType === 'sound' &&
                                <div className='row' style={{ border: "1px solid", padding: "1%" }}>
                                    <div className='col'>
                                        <b>sadece ses dosyası vardır</b>
                                        <div>
                                            <label className="form-label">{t("addPhoto")}</label>
                                            <input className="form-control" type="file" accept='image/*' onChange={(e) => handleMediaAction(e, 'photo', url => ({ text: questionTextState, type: 'image_sound', url: url, soundUrl: questionMedia }))} />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className="d-flex justify-content-center">
                                            <ReactAudioPlayer src={questionMedia} controls />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{t("addSound")}</label>
                                            <input className="form-control" type="file" accept='audio/*' onChange={(e) => handleMediaAction(e, 'sound', url => ({ text: questionTextState, type: 'sound', url: url }))} />
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center w-100 mt-3'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={handleDeleteMedia}>Medya {t("delete")}</button>
                                    </div>
                                </div>}
                        </div>
                    }

                    <br />
                    {/* BOŞ (MEDYASIZ) İSE YENİ EKLENTİ ALANI */}
                    {questionType === 'bos' &&
                        <div>
                            <h4>Soru başlığında medya bulunmamaktadır. Eklemek İçin:</h4>
                            <div className="accordion accordion-flush" style={{ backgroundColor: "gray" }}>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne">
                                            <h4>{t('addFile')}</h4> <i className="ms-2">Video ve resimler için minimum 1280*720 önerilir.</i>
                                        </button>
                                    </h2>
                                    <div id="flush-collapseOne" className="accordion-collapse collapse" style={{ backgroundColor: "white" }}>
                                        <div className="row" style={{ padding: "1%" }}>
                                            <div className="col-md-4">
                                                <div className="mb-1">
                                                    <label className="form-label">{t("addPhoto")}</label>
                                                    <input className="form-control" type="file" accept='image/*' onChange={(e) => handleMediaAction(e, 'photo', url => ({ text: questionTextState, type: 'image', url: url }))} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-1">
                                                    <label className="form-label">{t("addVideo")}</label>
                                                    <input className="form-control" type="file" accept='video/*' onChange={(e) => handleMediaAction(e, 'video', url => ({ text: questionTextState, type: 'video', url: url }))} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-1">
                                                    <label className="form-label">{t("addSound")}</label>
                                                    <input className="form-control" type="file" accept='audio/*' onChange={(e) => handleMediaAction(e, 'sound', url => ({ text: questionTextState, type: 'sound', url: url }))} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                    <br />
                    <div>
                        <div className="mb-3">
                            <label className="form-label">{t("infoBoxText")}</label>
                            <textarea className="form-control" value={notfyText} onChange={(e) => setNotfyText(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("questionText")}</label>
                            <textarea className="form-control" value={questionTextState} onChange={(e) => setQuestionTextState(e.target.value)} />
                        </div>
                        <div className='d-flex justify-content-center'>
                            <button type="submit" className="btn btn-primary btn-lg">{t("update")}</button>
                        </div>
                    </div>
                </form>
                <br /><hr />

                {/* --- CEVAP (ANSWER) GÜNCELLEME --- */}
                <form onSubmit={handleEdit} style={{ border: "1px solid black", padding: "10px" }}>
                    <div className="mb-3">
                        <label className="form-label">{t("correctAnswer")}</label><br />
                        <i>Lütfen büyük harfler ile yazınız.</i>
                        <textarea className="form-control" value={answer} onChange={(e) => setAnswer(e.target.value)} />
                    </div>
                    <div style={{ margin: "12px 0" }}>
                        <label style={{ display: "block", marginBottom: 6 }}>Parçalama türü</label>
                        <select className="form-select" value={splitMode} onChange={(e) => setSplitMode(e.target.value)}>
                            <option value="auto">Otomatik (Eski Sistemdeki gibi)</option>
                            <option value="mixed">Karışık (Harf Harf - volume up gibi)</option>
                        </select>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <button type="submit" className="btn btn-primary btn-lg">{t("update")}</button>
                    </div>
                </form>
                <br />
                Note: Cevap otomatik parçalanacaktır.
            </div>
            <hr />
        </div>
    );
};

export default Match;